import React, { useContext, useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import DASTDashboard from "../../../output-components/security-testing/DASTDashboard";
import DASTInputPage from "../../../input-components/security-testing/DASTInputPage";
import { SecurityFlowDataContext } from "../../SecurityTestingPage";
import BurpSuiteScansComponent from "../../../output-components/security-testing/BurpSuiteScansComponent";

const DastPhaseOutputPage = () => {
  const location = useLocation();
  const dashboardRef = useRef(null);
  const [dastScanResponse, setDastScanResponse] = useState([]);
  const [webURL, setWebURL] = useState("");
  const [runType, setRunType] = useState("");
  const { setDastScanResult } = useContext(SecurityFlowDataContext);

  useEffect(() => {
    if (location.state?.selectedScanner !== "BurpSuite") {
      setDastScanResult(location.state?.dastScanResult || []);
      setDastScanResponse(location.state?.dastScanResult);
      setWebURL(location.state?.webURL || "");
      setRunType(location.state?.runType || "");
    }
  }, [location.state]);

  useEffect(() => {
    // If scan data exists, scroll to the DASTDashboard section
    if (dastScanResponse && dashboardRef.current) {
      dashboardRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [dastScanResponse]);

  return (
    <Box>
      {location.state?.selectedScanner !== "BurpSuite" && <DASTInputPage />}

      {/* ******* DAST OUTPUT PAGE ******* */}
      {location.state?.selectedScanner !== "BurpSuite" &&
        Array.isArray(dastScanResponse) &&
        dastScanResponse.length > 0 && (
          <Box ref={dashboardRef}>
            <DASTDashboard
              dastScanData={dastScanResponse}
              webURL={webURL}
              runType={runType}
            />
          </Box>
        )}

      {location.state?.selectedScanner === "BurpSuite" && (
        <BurpSuiteScansComponent />
      )}
    </Box>
  );
};

export default DastPhaseOutputPage;
